import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiLeaguesService } from '../../../../services/leagues/api/api-leagues.service';
import { AlertsService } from '../../../../services/alerts.service';
import { League } from '../../../../models/leagues/league.model';

@Component({
  selector: 'app-league-add-modal',
  templateUrl: './league-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class LeagueAddModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  leagues: League[] = [];
  name: string = '';
  tier: number = 0;
  leaguePreviousId: number = null;
  leagueNextId: number = null;
  freeCreditsBonus: number = 0;

  private callbackSaved?: () => void;

  constructor(private apiLeaguesService: ApiLeaguesService, private alertsService: AlertsService) {}

  show(leagues: League[], callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.leagues = leagues;
    this.name = '';
    this.tier = 0;
    this.leaguePreviousId = null;
    this.leagueNextId = null;
    this.freeCreditsBonus = 0;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiLeaguesService.addLeague(this.name, this.tier, this.leaguePreviousId, this.leagueNextId, this.freeCreditsBonus).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('League added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding league : ' + error);
      }
    );
  }
}
